export const productFilters = [
  {
    id: 1,
    label: 'Tubular Steel',
    route: '/products/tubular-steel',
    depth: 0,
    children: [
      {
        label: 'Structural Tube & Pipe',
        route: '/products/tubular-steel/structural-tube-pipe',
        depth: 1,
        children: [
          {
            label: 'Rectangular Hollow Section (RHS)',
            route: '/products/tubular-steel/structural-tube-pipe/rectangular-hollow-section-rhs'
          },
          {
            label: 'Square Hollow Section (SHS)',
            route: '/products/tubular-steel/structural-tube-pipe/square-hollow-section-shs'
          },
          {
            label: 'Circular Hollow Section (CHS)',
            route: '/products/tubular-steel/structural-tube-pipe/circular-hollow-section-chs'
          },
          {
            label: 'Oval Rail',
            route: '/products/tubular-steel/structural-tube-pipe/oval-rail'
          }
        ]
      },
      {
        label: 'Precision Tube',
        route: '/products/tubular-steel/precision-tube',
        depth: 1,
        children: [
          {
            label: 'Rectangular',
            route: '/products/tubular-steel/precision-tube/rectangular'
          },
          {
            label: 'Square',
            route: '/products/tubular-steel/precision-tube/square'
          },
          {
            label: 'Round',
            route: '/products/tubular-steel/precision-tube/round'
          }
        ]
      }
    ]
  },
  {
    id: 2,
    label: 'Structural & Merchant Bar',
    route: '/products/structural-merchant-bar',
    depth: 0,
    children: [
      {
        label: 'Channels',
        route: '/products/structural-merchant-bar/channels',
        depth: 1,
        /*children: [
          {
            label: 'Mild Steel',
            route: '/products/channels/mild-steel',
          },
          {
            label: 'Galvanised',
            route: '/products/channels/galvanised',
          }
        ]*/
      },
      {
        label: 'Flat',
        route: '/products/structural-merchant-bar/flat',
        depth: 1,
        /*children: [
          {
            label: 'Mild Steel',
            route: '/products/flat/mild-steel',
          },
          {
            label: 'Galvanised',
            route: '/products/flat/galvanised',
          }
        ]*/
      },
      {
        label: 'Round',
        route: '/products/structural-merchant-bar/round',
        depth: 1
      },
      {
        label: 'Square',
        route: '/products/structural-merchant-bar/square',
        depth: 1
      },
      {
        label: 'Beams',
        route: '/products/structural-merchant-bar/beams',
        depth: 1
      },
      {
        label: 'Angle',
        route: '/products/structural-merchant-bar/angle',
        depth: 1
        /*children: [
          {
            label: 'Mild Steel Equal Angles',
            route: '/products/angle/mild-steel-equal-angles',
          },
          {
            label: 'Mild Steel Unequal Angles',
            route: '/products/angle/mild-steel-unequal-angles',
          }
        ]*/
      } 
    ]
  },
  {
    id: 3,
    label: 'Livestock Handling',
    route: '/products/livestock-handling',
    depth: 0,
    children: [
      {
        label: 'Cattle Handling',
        route: '/products/livestock-handling/cattle-handling',
        depth: 1,
        /*children: [
          {
            label: 'Crushes/Headbail',
            route: '/products/livestock-handling/cattle-handling/crushes',
          },
          {
            label: 'Ramps',
            route: '/products/livestock-handling/cattle-handling/ramps',
          },
          {
            label: 'Forcing Yards',
            route: '/products/livestock-handling/cattle-handling/forcing-yards',
          },
          {
            label: 'Panels',
            route: '/products/livestock-handling/cattle-handling/panels',
          },
          {
            label: 'Gates In Frames',
            route: '/products/livestock-handling/cattle-handling/gate-frames',
          },
          {
            label: 'Manway Panels',
            route: '/products/livestock-handling/cattle-handling/manway-panels',
          },
          {
            label: 'Manway Gates',
            route: '/products/livestock-handling/cattle-handling/manway-gates',
          },
          {
            label: 'Slide Gates',
            route: '/products/livestock-handling/cattle-handling/slide-gates',
          },
          {
            label: 'Bows',
            route: '/products/livestock-handling/cattle-handling/bows',
          },
          {
            label: 'Oval Rail',
            route: '/products/livestock-handling/cattle-handling/oval-rail',
          }
        ]*/
      },
      {
        label: 'Sheep Handling',
        route: '/products/livestock-handling/sheep-handling',
        depth: 1,
        /*children: [
          {
            label: 'Drafts',
            route: '/products/livestock-handling/sheep-handling/drafts',
          },
          {
            label: 'Ramps',
            route: '/products/livestock-handling/sheep-handling/ramps',
          },
          {
            label: 'Panels',
            route: '/products/livestock-handling/sheep-handling/panels',
          },
          {
            label: 'Gates In Frames',
            route: '/products/livestock-handling/sheep-handling/gate-frames',
          },
          {
            label: 'Manway Panels',
            route: '/products/livestock-handling/sheep-handling/manway-panels',
          },
          {
            label: 'Race Gate',
            route: '/products/livestock-handling/sheep-handling/race-gate',
          },
          {
            label: 'Slide Gates',
            route: '/products/livestock-handling/sheep-handling/slide-gates',
          },
          {
            label: 'Bows',
            route: '/products/livestock-handling/sheep-handling/bows',
          },
        ]*/
      },
      {
        label: 'Goat Equipment',
        route: '/products/livestock-handling/goat-equipment',
        depth: 1,
        /*children: [
          {
            label: 'Panels',
            route: '/products/livestock-handling/goat-equipment/panels',
          },
        ]*/
      },
      {
        label: 'Horse Equipment',
        route: '/products/livestock-handling/horse-equipment',
        depth: 1,
        /*children: [
          {
            label: 'Panels',
            route: '/products/livestock-handling/horse-equipment/panels',
          },
          {
            label: 'Gates In Frames',
            route: '/products/livestock-handling/horse-equipment/gate-frames',
          }
        ]*/
      },
      {
        label: 'Feeders',
        route: '/products/livestock-handling/feeders',
        depth: 1
      },
      {
        label: 'Accessories',
        route: '/products/livestock-handling/accessories',
        depth: 1
      }
    ]
  },
  {
    id: 4,
    label: 'Fencing',
    route: '/products/fencing',
    depth: 0,
    children: [
      {
        label: 'Gates',
        route: '/products/fencing/gates',
        depth: 1
      },
      {
        label: 'Wire',
        route: '/products/fencing/wire',
        depth: 1
      },
      {
        label: 'Accessories',
        route: '/products/fencing/accessories',
        depth: 1
      }
    ]
  },
  {
    id: 5,
    label: 'Other',
    route: '/products/other',
    depth: 0,
    children: [
      {
        label: 'Paint',
        route: '/products/other/paint',
        depth: 1
      },
      {
        label: 'Welding',
        route: '/products/other/welding',
        depth: 1
      },
      {
        label: 'Cutoff & Grinding Disc',
        route: '/products/other/grinding-discs',
        depth: 1
      },
      {
        label: 'Load Restraints',
        route: '/products/other/load-restraints',
        depth: 1
      },
      {
        label: 'Accessories',
        route: '/products/other/accessories',
        depth: 1
      }
    ]
  },
  {
    id: 6,
    label: 'All Products',
    route: '/products/all',
    depth: 0
  }
]
